import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../lib/api'

export type CriterioQai =
  | 'apenas_registrar'
  | 'menor_que'
  | 'menor_ou_igual'
  | 'maior_que'
  | 'maior_ou_igual'
  | 'entre'
  | 'igual_a'
  | 'nao_detectavel'

export interface PontoAmostragemQai {
  id?: string
  area: string | null
  area_nome?: string
  identificacao: string
  tipo: 'interno' | 'externo_referencia'
  local_coleta: string
  ordem: number
}

export interface CriterioResultadoQai {
  id?: string
  parametro: string
  unidade: string
  criterio: CriterioQai
  valor_min: string | null
  valor_max: string | null
  valor_referencia: string | null
  obrigatorio: boolean
  observacoes: string
  ordem: number
}

export interface DimensionamentoQaiNBR {
  area_climatizada_m2: string | null
  quantidade_minima: number | null
  areas_sem_metragem: Array<{ id: string; nome: string }>
  areas: Array<{
    id: string
    nome: string
    codigo: string
    metragem_m2: string | null
    qtd_ocupantes: number | null
  }>
}

export interface PlanoAmostragemQai {
  id?: string
  configurado: boolean
  periodicidade_meses: number
  quantidade_minima: number
  quantidade_maxima: number | null
  quantidade_planejada: number
  criterio_dimensionamento: string
  referencia_normativa: string
  observacoes: string
  pontos: PontoAmostragemQai[]
  criterios: CriterioResultadoQai[]
  criterios_padrao_nbr: CriterioResultadoQai[]
  dimensionamento_nbr: DimensionamentoQaiNBR
}

export function usePlanoQai(pmocId: string) {
  return useQuery({
    queryKey: ['plano-qai', pmocId],
    queryFn: async () => {
      const response = await api.get<PlanoAmostragemQai>(
        `/pmoc/${pmocId}/plano-amostragem-qai/`,
      )
      return response.data
    },
    enabled: !!pmocId,
  })
}

export function usePlanoQaiSalvar(pmocId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (data: PlanoAmostragemQai) => {
      const response = await api.put<PlanoAmostragemQai>(
        `/pmoc/${pmocId}/plano-amostragem-qai/`,
        data,
      )
      return response.data
    },
    onSuccess: (data) => queryClient.setQueryData(['plano-qai', pmocId], data),
  })
}
